var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabbed',{attrs:{"title":"Detalle de la transacción"}},_vm._l((_vm.tables),function(info){return _c('PaymentInvoice',{key:info.folio,attrs:{"info":info}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }